import React from "react";
import classes from "./CandyCaneSpinner.module.scss";

const CandyCaneSpinner = () => {
  return <div className={`candy_cane tall ${classes.spinner}`}></div>;
};

export default CandyCaneSpinner;
